export const WindowDispatchEvent = {
  UPDATE_ANONYMOUS_STATE: 'UPDATE_ANONYMOUS_STATE',
  UPDATE_TOP_LEFT_ITEMS: 'UPDATE_TOP_LEFT_ITEMS',
  UPDATE_TOP_RIGHT_ITEMS: 'UPDATE_TOP_RIGHT_ITEMS',
  UPDATE_CITIES: 'UPDATE_CITIES',
  UPDATE_DISTRICTS: 'UPDATE_DISTRICTS',
  UPDATE_BASKET: 'UPDATE_BASKET',
  UPDATE_FOOTER: 'UPDATE_FOOTER',
  UPDATE_SELECTED_CITY: 'UPDATE_SELECTED_CITY',
  UPDATE_USER: 'UPDATE_USER',
  UPDATE_FAVORITES: 'UPDATE_FAVORITES',
  SHOW_CART_EXIT_INTENT: 'SHOW_CART_EXIT_INTENT',
};
